import { LoginService } from '~/lib/LoginService'

const ServicesPlugin = ({ store, route, $envConfig, redirect }, inject) => {
  inject('services', {
    login: new LoginService($envConfig, store, route, redirect)
  })
}

export default ServicesPlugin
